// https://stackoverflow.com/a/9039885
const IOS_PLATFORM_REGEX = /iPad|iPhone|iPod/
export function isIOS() {
  return !!navigator.platform && IOS_PLATFORM_REGEX.test(navigator.platform)
}
